import { createActions } from 'redux-actions';

export const getType = (reduxAction) => {
  return reduxAction.type;
};

export const getWarehouses = createActions({
  getWarehousesRequest: (payload) => payload,
  getWarehousesSuccess: (payload) => payload,
  getWarehousesFailure: (error) => error,
});

export const createWarehouse = createActions({
  createWarehouseRequest: (payload) => payload,
  createWarehouseSuccess: (payload) => payload,
  createWarehouseFailure: (error) => error,
});

export const updateWarehouse = createActions({
  updateWarehouseRequest: (payload) => payload,
  updateWarehouseSuccess: (payload) => payload,
  updateWarehouseFailure: (error) => error,
});

export const deleteWarehouse = createActions({
  deleteWarehouseRequest: (payload) => payload,
  deleteWarehouseSuccess: (payload) => payload,
  deleteWarehouseFailure: (error) => error,
});
